export const ROOT = '/';
export const NOTIFICATIONS = '/notifications';
export const ADD_POST = '/add_post';
export const EDIT_POST = '/edit_post';
export const PROFILE = '/profile';
export const USER_PROFILE = '/u/:userId?/:name?';
export const MESSAGES = '/messages';

export const LOGIN = '/login';
export const REGISTER = '/register';
export const PASSWORD_RESET = '/password_reset';
export const NEW_PASSWORD = '/new_password';

export const MENUSETTINGS = '/menusettings';
export const SETTINGS = '/settings';
export const SETTINGS_PROFILE = '/settings/profile';
export const SETTINGS_ACCOUNT = '/settings/account';
export const SETTINGS_FINANCIAL = '/settings/financial';
export const CHOOSE_ARTWORK = '/settings/artwork';

export const HELP_SUPPORT = '/support';
export const ACCOUNT_SUPPORT = '/support/account';
export const QUESTION_SUPPORT = '/support/questions';
export const SEARCH_SUPPORT = '/support/search';
export const ACCOUNT_SECURITY_SUPPORT = '/support/acc_security';
export const GENERAL_QUESTIONS_SUPPORT = '/support/general_questios';
export const PRIVACY_TERMS_SUPPORT = '/support/privacy_terms';
export const SUBSCRIPTION_FAQ = '/support/sub_faq';
export const PAYMENT_FAQ = '/support/payment_faq';
export const TIPS_FAQ = '/support/tips_faq';
export const MY_WALLET_FAQ = '/support/my_wallet';
export const VALUE_TAX_FAQ = '/support/value_tax';
export const BECOME_CREATOR_SUPPORT = '/support/become_creator';
export const CREATOR_ERNING_PAYOUTS_SUPPORT = '/support/erning_payouts';
export const CREATOR_TIPS_SUPPORT = '/support/tips';
export const CREATOR_ACC_SUPPORT = '/support/creator_acc';
export const CREATOR_ACC_SET_SUPPORT = '/support/creator_acc_settings';
export const CREATOR_TAG_SUPPORT = '/support/creator_tag';
export const CREATOR_PROMOTING_SUPPORT = '/support/creator_promoting';
export const CREATOR_REF_SUPPORT = '/support/creator_ref';
export const CREATOR_TECH_SUPPORT = '/support/creator_tech';
export const CREATOR_VALUE_SUPPORT = '/support/creator_value';
export const CREATOR_TAX_INF_SUPPORT = '/support/creator_tax_inf';

export const ADD_CARD = '/add_card';
export const BANK_ACCOUNT = '/bank_account';


export const ADD_BANK = '/add_bank';
export const CONTACT_US = '/contact';
export const PAYMENTS = '/payments';
export const LISTS = '/lists';
export const BOOKMARKS = '/bookmarks';
export const SAVED_POSTS = '/saved_posts';
export const LIKEDPOSTS = '/likedPosts';
export const PURCHASEDPOSTS = '/purchasedPosts';
export const SUBSCRIBERS = '/subscribers';
export const SUBSCRIPTIONS = '/subscriptions';
export const SINGLE_POST = '/post/:id';
export const TEMP_POST = '/post/';
export const UPDATE_POST = 'posts/:id';
export const CHANNELS = "/channels"
export const MEMBERS = '/members';

export const ADMIN = '/admin';
export const ADMIN_REPORTS = '/admin/reports';

export const TERMS = '/terms';
export const PRIVACY = '/privacy';
export const P404 = '/404';

export const TERMS_PRIVACY = '/terms_privacy';

export const SEARCH = '/search';
export const GOOGLE_AUTH = 'auth/google';

export const SEND_MESSAGE = '/send_message';
export const EMAIL_EXPIRED = '/email_expired';



